<template lang="pug">
  ul.tags(v-if="itens.length")
    li.item(v-for='item of itens', :key="item.id")
      router-link.link(:to="{ name: 'Noticias', params: { page: 1, tag: item.slug }  }") {{ item.nome }}
</template>

<style lang="scss">
  .tags {
    display: block;
    > .item {
      display: inline-block;
      margin: 5px 3px 5px 3px;
      &:first-child { margin-left: 0; }
      > .link {
        font-size: 85%;
        border-radius: 5px;
        padding: 3px 9px;
        text-transform: lowercase;
        background-color: $color-green-light;
        &:focus, &:hover, &:active {
          background-color: $color-green-dark;
          color: $color-neutral;
          text-decoration: none;
        }
      }

    }
  }
</style>

<script>
  export default {
    name: 'tags',
    props: ['itens']
  }
</script>



// WEBPACK FOOTER //
// Tags.vue?2cd2cdcc